import {Component, Input} from "@angular/core";
import {FormGroup, FormBuilder, FormControl} from '@angular/forms';
import {UserService} from "~/app/core/services/user.service";
import {StatementsService} from "~/app/web/statements/statements.service";
import {InvoicesService} from "~/app/core/services/invoices.service";
import {Parent} from "@model/Parent";
import * as moment from 'moment';
import {DialogType, FSInvoiceDialogService} from "~/app/core/services/fsinvoice.dialog.service";
import {LoggingService} from 'mclane-apptemplate-lib';
import {InvoiceStore} from "@model/InvoiceStore";
import {Invoice} from "@model/Invoice";
import {HttpEventType} from "@angular/common/http";
import {DownloadDialogComponent} from "~/app/web/invoices/downloadDialog/download-dialog.component";
import {DownloadRequest} from "@model/DownloadRequest";
import { LoadingIndicatorHelper } from "~/app/core/services/loading-indicator-helper";
import { lastValueFrom } from "rxjs";
@Component({
  selector: 'app-invoice-lookup',
  templateUrl: './invoice-lookup.component.html',
  styleUrls: ['./invoice-lookup.component.scss']
})

export class InvoiceLookupComponent {
  @Input() userParentList: Parent[];
  parentsString: string = '';
  userStoreList: string = '';
  userInvoiceList: Invoice[] = [];
  noAccessList: string[] = [];
  invoiceArray: string[];
  selectionChoice: string[] = ['Invoice Number', 'Order Number'];
  selectedValue: string = '';
  invoiceLookupForm: FormGroup;
  invoiceList: string = '';
  orderList: string[]=[];
  orderInvoiceList: string = '';
  typeSelection: string = 'Invoice Number';
  today = moment(new Date()).format( 'YYYY-MM-DD');
  userName: string;
  response: any;
  missing: string;
  pdf: string;
  count: number;
  invoicesString: string[];
  newParents: string[];
  requestDownload: DownloadRequest = new DownloadRequest();
  newStores: string[] = [];

  constructor (public formBuilder: FormBuilder,
               public userService: UserService,
               public statementService: StatementsService,
               public invoiceService: InvoicesService,
               public fsInvoiceDialog: FSInvoiceDialogService,
               public console: LoggingService,
               public loadingIndicator: LoadingIndicatorHelper,
               private _userService: UserService) {
  }

  async ngOnInit() {
    this.invoiceLookupForm = this.formBuilder.group({
      typeSelection: new FormControl(this.typeSelection),
      invoiceList: new FormControl(this.selectedValue)
    })
    await this.userParentList.forEach(item => {
      this.parentsString += item.id + ',';
    });
    this.parentsString = await this.parentsString.substring(0, this.parentsString.length - 1);
    await this.getUserStoreList();
    await this.getUserInvoiceList();
  }

  async viewClicked(e) {
    this.loadingIndicator.show();

    if (this.typeSelection === 'Invoice Number') {
      this.invoiceList = this.orderInvoiceList.replace(/[\n]/gm, ",");
    } else {
      this.orderInvoiceList = this.orderInvoiceList.replace(/[\n]/gm, ",");
      this.orderList = this.orderInvoiceList.split(',');
      this.invoiceList = '';
      this.orderList.forEach(order => {
        this.userInvoiceList.forEach(item => {
          if(order === item.orderNumber.toString()) {
            this.invoiceList += item.invoiceNumber + ',';
          }
        });
      });
      this.invoiceList = await this.invoiceList.substring(0, this.invoiceList.length - 1);
    }

    this.invoiceArray = this.invoiceList.split(',');
    this.invoiceList = '';
    this.invoiceList.trim();
    await this.invoiceAccessCheck(this.invoiceArray);

    this.invoiceArray.forEach(item => {
      this.invoiceList += item + ',';
    });
    this.invoiceList = await this.invoiceList.substring(0, this.invoiceList.length - 1);
    this.invoiceList.trim();

    if(this.noAccessList.length !== 0) {
      this.fsInvoiceDialog.showMessageDialog('No User Access', 'Not able to access ' + this.noAccessList);
      this.loadingIndicator.hide();
      this.noAccessList = [];
    }
    if(this.invoiceList === '') {
      this.loadingIndicator.hide();
      return;
    }
    await this.getInvoices();
  }

  onChange(e) {
    this.typeSelection = e;
  }

  invoiceListChange(value: any) {
    this.orderInvoiceList = value;
  }

  async downloadClicked(e) {
    this.loadingIndicator.show();
    if (this.orderInvoiceList.indexOf(',') > -1) {
      this.orderInvoiceList = this.orderInvoiceList.replace(/[\n]/gm, "");
    } else {
      this.orderInvoiceList = this.orderInvoiceList.replace(/[\n]/gm, ",");
    }
    if (this.typeSelection === 'Invoice Number') {
      this.invoiceList = this.orderInvoiceList;
    } else {
      this.orderList = this.orderInvoiceList.split(',');
      this.invoiceList = '';
      this.orderList.forEach(order => {
        this.userInvoiceList.forEach(item => {
          if(order === item.orderNumber.toString()) {
            this.invoiceList += item.invoiceNumber + ',';
          }
        });
      });
      this.invoiceList = await this.invoiceList.substring(0, this.invoiceList.length - 1);
    }

    this.invoiceArray = this.invoiceList.split(',');
    this.invoiceList = '';
    this.invoiceList.trim();
    await this.invoiceAccessCheck(this.invoiceArray);

    this.invoiceArray.forEach(item => {
      this.invoiceList += item + ',';
    });
    this.invoiceList = await this.invoiceList.substring(0, this.invoiceList.length - 1);
    this.invoiceList.trim();

    if(this.noAccessList.length !== 0) {
      this.fsInvoiceDialog.showMessageDialog('No User Access', 'Not able to access ' + this.noAccessList);
      this.loadingIndicator.hide();
      this.noAccessList = [];
    }
    if(this.invoiceList === '') {
      this.loadingIndicator.hide();
      return;
    }
    await this.getInvoiceDownload();
  }

  async getUserStoreList() {
    await lastValueFrom(this.invoiceService.getStores(this.parentsString))
      .then(result => {
        result.forEach(item => {
          this.userStoreList += item.shipToSiteNumber + ',';
        });
      });
    this.userStoreList = this.userStoreList.substr(0, this.userStoreList.length - 1);
  }

  async getUserInvoiceList() {
    await lastValueFrom(this.invoiceService.getInvoicesSummary(this.parentsString, this.userStoreList, 'I', 'N', 0, 0,  '1900-01-01', this.today))
      .then(res => {
        this.userInvoiceList = res;
      });
  }

  invoiceAccessCheck(invoiceArray: string[]) {
    invoiceArray.forEach((item, idx) => {
      this.count = 0
      this.userInvoiceList.forEach(invoice => {
        if (item === invoice.invoiceNumber.toString()) {
          this.count = this.count + 1;
        }
      });
      if (this.count === 0) {
        invoiceArray.splice(idx, 1);
        this.noAccessList.push(item);
      }
    });
  }

  async getInvoices() {
    await lastValueFrom(this.invoiceService.getInvoices(this.invoiceList))
      .then(r => {
        this.response = r;
        this.response = this.response.trim();
        let s = this.response.charAt(0);
        if (s >= '0' && s <= '9') {
          this.missing = this.response;
          this.fsInvoiceDialog.showMessageDialog('Missing invoices', 'Not able to access ' + this.missing);
          this.loadingIndicator.hide();
        } else {
          let someString = this.response.toString();
          let index = someString.indexOf(' ');
          if (index == -1) {
            index = someString.length;
            this.pdf = someString.substr(0, index);
          } else {
            this.pdf = someString.substr(0, index);
            this.missing = someString.substr(index + 1);
            this.missing = this.missing.slice(0, -1);
            if (typeof this.pdf != 'undefined' && this.pdf) {
              this.fsInvoiceDialog.showMessageDialog('Missing invoices', 'Invoices ' + this.missing + ' are missing from pdf.');
            }
          }
          let binary_string = window.atob(this.pdf);
          let len = binary_string.length;
          let bytes = new Uint8Array(len);
          for (let i = 0; i < len; i++) {
            bytes[i] = binary_string.charCodeAt(i);
          }
          let file = new Blob([bytes.buffer], {type: 'application/pdf'});
          let fileURL = URL.createObjectURL(file);

          this.loadingIndicator.hide();
          window.open(fileURL);
        }
      });
  }

  getInvoiceDownload() {
   //get store list for invoices
    let invoiceArr = this.invoiceList.split(',');
    this.newStores = this.getStoresForDownload(invoiceArr);
    if (this.invoiceList.length > 1350) {
      this.fsInvoiceDialog.openDialog({
        type: DialogType.ERROR,
        title: 'Export',
        content: this.invoiceList.length + ' invoices are selected. Maximum 1350 invoices can be exported at a time.',
        actions: [
          {text: 'Ok', primary: true},
        ],
        width: 400
      }).then(r => r);
    } else {
      if (this.invoiceList.length > 0) {
        const dialogRef = this.fsInvoiceDialog.open({
          type: DialogType.INFO,
          title: 'Available Downloads',
          content: DownloadDialogComponent,
          actions: [
            {text: 'Cancel', primary: false},
            {text: 'Download', primary: false}
          ],
          width: 400
        });
        this.loadingIndicator.hide();

        this.invoicesString = this.invoiceList.split(',');
        this.invoicesString = this.invoicesString.map(function (value) {
          return String(value);
        });

        this.newParents = this.parentsString.split(',');

        let tempParents = this.newParents.toString();
        this.newParents = [];
        this.newParents[0] = tempParents;

        this.requestDownload.parents = this.newParents;

        let tempStores = this.newStores.toString();
        this.newStores = [];
        this.newStores[0] = tempStores;
        this.requestDownload.stores = this.newStores;

        this.requestDownload.invoices = this.invoicesString;
        this.requestDownload.type = "I";
        this.requestDownload.onlyNew = false;

        const dialogContent = dialogRef.content.instance;
        dialogRef.result.subscribe((answer: any) => {
          if (answer.text === 'Download') {
            let results = dialogContent.formGroup.value;
            Object.keys(results).forEach(key => {
              if (key === "CSV" && results[key] === true  && results["Formatted"] === false) {
               // this.opened = true;
               lastValueFrom(this.invoiceService.downloadCSV(this.requestDownload))
                  .then((r) => {
                    this.downloadFile(r, 'csv');
                   // this.opened = false;
                  }).catch((error) => {
                //  this.opened = false;
                  this._userService.showError('Problem Downloading CSV Invoice', 2000);
                  console.error(error);
                });
              }
              else if (key === "CSV" && results['CSV'] === true && results['Formatted'] === true) {
                lastValueFrom(this.invoiceService.downloadCSVFormatted(this.requestDownload))
                  .then((r) => {
                    this.downloadFile(r, 'csv');
                  }).catch((error) => {
                  this._userService.showError('Problem Downloading CSV Invoice', 2000);
                  console.error(error);
                });
              }
              else if (key === "XML" && results[key] === true) {
                lastValueFrom(this.invoiceService.downloadXML(this.requestDownload))
                  .then(r => {
                    this.downloadFile(r, 'xml');
                    this.loadingIndicator.hide();
                  }).catch((error) => {
                  this._userService.showError('Problem Downloading XML Invoice', 2000);
                  console.error(error);
                });
              }
            });
          } else {
          }
        });
      } else {
        this.fsInvoiceDialog.openDialog({
          type: DialogType.ERROR,
          title: 'Export',
          content: 'Please add at least one Invoice to export.',
          actions: [
            {text: 'Ok', primary: true},
          ],
          width: 400
        }).then(r => r);
      }
    }
  }

  getStoresForDownload(list: string[]) {
    list.forEach(invoice => {
      this.userInvoiceList.forEach(item => {
        if(invoice === item.invoiceNumber.toString()) {
          this.newStores.push(item.customer);
        }
      });
    });
    return this.newStores;
  }

  downloadFile(data: any, type: string) {
    if (type === 'csv') {
      const newBlob = new Blob([data], {type: 'application/csv'});
      const downloadURL = window.URL.createObjectURL(newBlob);
      const link = document.createElement('a');
      link.href = downloadURL;
      link.download = 'invoice.csv';
      link.click();
    } else if (type === 'xml') {
      const newBlob = new Blob([data], {type: 'application/xml'});
      const downloadURL = window.URL.createObjectURL(newBlob);
      const link = document.createElement('a');
      link.href = downloadURL;
      link.download = 'invoice.xml';
      link.click();
    }
  }
}
